import { useContext } from 'react';
import { useParams } from 'react-router-dom';
import classes from './UserProfile.module.css';
import NavBar from '../../components/NavBar/NavBar.jsx';
import User from '../../components/UserPage/User';
import MainContainer from '../../components/UserPage/MainContainer';
import Footer from "../../components/HomePage/Footer";
import { Link, useNavigate } from 'react-router-dom';
import { useProfilePageUser } from '../../hooks/useProfilePageUser';
import { NavBarContext } from '../../App';

export const UserProfile = () => {
  const { showSignIn, showRegister } = useContext(NavBarContext);
  const navigate = useNavigate();
  const { id } = useParams();

  const { userData, loading, error } = useProfilePageUser(id);

  const renderContent = () => {
    if (error) {
      return (
        <div className={classes.errorContainer}>
          <p>Das Profil konnte nicht geladen werden. Bitte versuche es später erneut.</p>
        </div>
      );
    }

    // Add additional safety checks
    if (!id) {
      return (
        <div className={classes.errorContainer}>
          <p>Dieses Profil konnte nicht gefunden werden.</p>
        </div>
      );
    }

    return (
      <main>
        <User 
          user={userData?.user} 
          isLoading={loading} 
        />
        <MainContainer
          user={userData?.user} 
          studios={userData?.studios || []} 
          hasStudios={userData?.hasStudios}
          isLoading={loading}
        />
      </main>
    );
  };

  return (
    <div 
      className={`${classes.container} ${showSignIn || showRegister ? classes.width : ''}`}
    >
        <div className={classes.navBarContainer}>
          <NavBar fromUserProfile={true} />
        </div>
        <div className={classes.mobileNavBar}>
          <button className={classes.backButton} onClick={() => navigate(-1)}>
            <svg xmlns="http://www.w3.org/2000/svg" width="9" height="17" viewBox="0 0 9 17" fill="none">
              <path fillRule="evenodd" clipRule="evenodd" d="M0 8.04259L7.90197 0.140625L8.95756 1.19622L2.07028 8.0835L9 15.5907L7.90306 16.6032L0.0119278 8.05452L0 8.04259Z" fill="black"/>
            </svg>
          </button>
          <Link to="/" className={classes.logoContainer}>
            <svg xmlns="http://www.w3.org/2000/svg" width="53" height="18" viewBox="0 0 53 18" fill="none">
              <path d="M50.5002 9C51.8809 9 53.0002 7.88071 53.0002 6.5C53.0002 5.11929 51.8809 4 50.5002 4C49.1195 4 48.0002 5.11929 48.0002 6.5C48.0002 7.88071 49.1195 9 50.5002 9Z" fill="#FF003E"/>
              <path d="M9.93692 9.28445L8.58239 9.17069C5.23081 8.89942 4.10204 8.5494 4.10204 7.7881C4.10204 7.0268 5.52603 6.60677 8.46083 6.60677C11.5606 6.60677 12.8109 7.01805 13.0714 8.12062L13.1148 8.29563H16.5185L16.4838 8.05062C16.1452 5.14542 13.5577 3.73658 8.58239 3.73658C3.60712 3.73658 1.05437 5.11917 1.05437 7.83185C1.05437 10.317 3.09483 11.5158 8.11352 11.9709L9.32912 12.0846C12.6546 12.3734 13.8876 12.8109 13.8876 13.686C13.8876 14.6398 12.3681 15.1298 9.36385 15.1298C5.96017 15.1298 4.2236 14.491 4.05863 13.1697L4.03258 12.9772H0.628906V13.2135C0.785197 16.3899 3.63317 18 9.10336 18C14.5736 18 16.944 16.4949 16.944 13.5285C16.944 10.8858 14.9817 9.69572 9.93692 9.28445Z" fill="#1F1F1F"/>
              <path d="M42.1415 4.17403V9.8444C42.1415 13.0209 40.0663 14.9897 36.7321 14.9897C33.5976 14.9897 32.3733 13.5809 32.3733 9.95816V4.17403H21.8497V0L18.7152 1.33009V13.2834C18.7152 16.5823 20.2954 17.9912 24.003 17.9912C25.2968 17.9912 26.5384 17.7724 27.589 17.5537L27.7627 17.5187V14.7097L27.5022 14.7622C26.139 15.0422 25.5312 15.1473 24.5587 15.1473C22.7614 15.1473 21.8497 14.7185 21.8497 12.3646V6.7992H30.793L29.1433 8.05928V10.982C29.1433 15.7685 31.1577 17.9912 35.4731 17.9912C38.2603 17.9912 40.5525 17.0199 42.1415 15.1648V17.5537H45.3715V4.17403H42.1415Z" fill="#1F1F1F"/>
            </svg>
          </Link>
          <div></div>
        </div>
      {renderContent()}
      <Footer />
    </div>
  );
};

export default UserProfile;
